import { PDFDownloadLink, PDFViewer, StyleSheet } from "@react-pdf/renderer";
import CertificateAttendance from "../../shared/components/Templates/CertificateAttendance";
import { useEffect, useState } from "react";
import { fetchCertByRef } from "../../api/Evaluation";
import "./styles.css";
import CertificateAttendanceV2 from "../../shared/components/Templates/CertificateAttendanceV2";
import { formatDate } from "../../util/date";

const styles = StyleSheet.create({
  viewer: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
});

const getCertSubDetails = ({ schedules = "[]", type }) => {
  let totalHours = 0;

  const parsedSchedules = JSON.parse(schedules);

  parsedSchedules.forEach((schedule) => {
    const [hourIn] = schedule.timeIn.split(":");
    const [hourOut] = schedule.timeOut.split(":");

    const timeDiff = parseInt(hourOut) - parseInt(hourIn);

    totalHours += timeDiff;
  });

  return `for attending the ${totalHours}-hour ${type} entitled`;
};

const getCertDates = ({ schedules = "[]", venue }) => {
  const parsedSchedules = JSON.parse(schedules);

  if (parsedSchedules.length === 0) return "";

  if (parsedSchedules.length === 1)
    return `on ${formatDate(parsedSchedules[0].date)} via ${venue}`;

  const months = ["January","February","March","April","May","June","July",
    "August","September","October","November","December"];

  const [firstYear, firstMonth, firstDay] = parsedSchedules[0].date.split("-");
  const [lastYear, lastMonth, lastDay] = parsedSchedules.at(-1).date.split("-");

  return `on ${months[parseInt(firstMonth) - 1]} ${parseInt(firstDay)}${firstDay !== lastDay ? ` - ${parseInt(lastDay)}` : ``}, ${lastYear} via ${venue}`;
};

const CertificatePage = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const refLink = urlParams.get('refId');
  const [error, isError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [name, setName] = useState("");
  const [certData, setCertData] = useState({});

  const handleError = () => {
    isError(true);
  };

  const loadData = async () => {
    const data = await fetchCertByRef(refLink);

    if (!data) return handleError();

    setIsLoading(false);

    const { personal_name, last_name } = data;

    setName(() => {
      const personal = personal_name.split(" ").map(str => {
        return str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();
      }).join(" ");

      const last = last_name.split(" ").map(str => {
        return str.substring(0, 1).toUpperCase() + str.substring(1).toLowerCase();
      }).join(" ");

      return `${personal} ${last}`;
    });

    setCertData(data);
  };

  useEffect(() => {

    if (name && !error && !isLoading && refLink) {
      console.log("Clicking download link", document)
      const downloadBtn = document.querySelector(".certificate__download--button");

      const downloadLink = downloadBtn.querySelector("a");

      setTimeout(() => {
        downloadLink.click();
      }, 2000)
    }

  }, [name, error, isLoading, refLink])

  useEffect(() => {
    loadData();
  }, [])

  const documentCert = (
    <CertificateAttendance
      name={name}
      title={certData?.title}
      subDetails={getCertSubDetails(certData)}
      topics={JSON.parse(certData?.topics || "[]")}
      datesDetails={getCertDates(certData)}
    />
  )

  return (refLink && !error && !isLoading && documentCert) && (
    <div className="certificate__wrapper">
      <div className="certificate__download--button" style={{ position: "absolute", zIndex: -1, visibility: "hidden" }}>
        <PDFDownloadLink fileName={`${name} - Certificate`} document={documentCert}>
          Download Now
        </PDFDownloadLink>
      </div>

      <div className="certificate__details">
        <img src="http://petros-global.com/uploads/logo/medal.png" />

        <br />

        <p>Congratulations! Your certificate is being downloaded now.</p>

        <br />

        <br />

        Please click <PDFDownloadLink fileName={`${name} - Certificate`} document={documentCert}>
          Download Now
        </PDFDownloadLink>, if the certificate did not download automatically.
      </div>
    </div>
  )
};

export default CertificatePage;